<div [class.reminderAlert__snoozed]="isSnoozed" class="reminderAlert__timestamp">
  <pp-icon [ppSrc]="EIconPath.ICON_FIELDS_TIME_18" ppColor="inherit" ppClass="setSize18"></pp-icon>

  <span class="reminderAlert__timestampText">{{ timeText }}</span>
</div>
